import { isValidToken } from './AuthUtil';
import { GR8PI_CREDENTIALS_STORE_KEY } from '../../utils/Gr8piConfig';

const LOCKED_OUT = 'LOCKED_OUT';
const LOCKED_OUT_TIMESTAMP = 'LOCKED_OUT_TIMESTAMP';

export const isLockedOut = () => {
  const lockedOut = localStorage.getItem(LOCKED_OUT);

  if (lockedOut) return lockedOut === 'true';

  return false;
};

export const setLockedOut = (lockedOut) => {
  localStorage.setItem(LOCKED_OUT, lockedOut);
};

export const getLockedOutTimestamp = () => {
  const timestamp = localStorage.getItem(LOCKED_OUT_TIMESTAMP);

  if (timestamp) return new Date(timestamp);

  return null;
};

export const setLockedOutTimestamp = (timestamp) => {
  localStorage.setItem(LOCKED_OUT_TIMESTAMP, timestamp);
};

export const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
};

export const getCredentialsSession = () => {
  try {
    const credentialsSession = JSON.parse(localStorage.getItem(GR8PI_CREDENTIALS_STORE_KEY));
    return credentialsSession || {};
  } catch (error) {
    return {};
  }
};

export const isUserRole = (permissions, permissionRole) => {
  const checkPermission = permissions.indexOf(permissionRole);
  if (checkPermission >= 0) {
    return true;
  }
  return false;
};

export const persistCredentialsSession = (accessToken, refreshToken) => {
  localStorage.setItem(GR8PI_CREDENTIALS_STORE_KEY, JSON.stringify({
    accessToken,
    refreshToken,
  }));
};

export const clearCredentialsSession = () => {
  localStorage.setItem(GR8PI_CREDENTIALS_STORE_KEY, JSON.stringify({
    accessToken: null,
    refreshToken: null,
  }));
  localStorage.setItem('removeGr8piCredentialsEvent', Date.now());
};

export const getAccessToken = () => {
  const credentials = getCredentialsSession();
  if (isValidToken(credentials.accessToken)) {
    return credentials.accessToken;
  }
  return null;
};

export const isAuthorizedUser = (permissionRole) => {
  const token = getAccessToken();
  if (token) {
    const inforFromToken = parseJwt(token);
    const { permissions } = inforFromToken;
    return isUserRole(permissions, permissionRole);
  }
  return false;
};
